import React from "react";
import PropTypes from 'prop-types';
import { Button, Modal, Icon } from 'antd';
import { confirmDialog as strings } from 'ui/constants/strings';

const styles = {
  confirmDialog: {
    borderRadius: 0,
  },
}

class ConfirmDialog extends React.PureComponent {

  render() {
    const {
      data,
      visible,
      headerText,
      bodyText,
      confirmButtonText,
      cancelButtonText,
      iconType,
      hideCancelButton,
      hideCloseIcon,
      confirmButtonClass,
      cancelButtonClass,
      onConfirm,
      onCancel,
    } = this.props;

    const title = (
      <div className='dialogTitle'>
        { headerText }
      </div>
    )
    const foorter = (
      <div className='dialogFooter'>
        <Button
          className={`footerSaveButtin ${confirmButtonClass}`}
          onClick={() => {
            onConfirm(data);
            onCancel();
          }}
        >
          { confirmButtonText }
        </Button>
        {
          !hideCancelButton &&
          <Button className={`footerCancelButton ${cancelButtonClass}`} onClick={onCancel}>
            { cancelButtonText }
          </Button>
        }
      </div>
    )

    return (
      <Modal
        style={styles.confirmDialog}
        centered
        visible={visible}
        maskClosable={false}
        closable={!hideCloseIcon}
        title={title}
        footer={foorter}
        onCancel={onCancel}
      >
        <div className='confirmDialogText'>
          { iconType && <Icon type={iconType} /> }
          { bodyText }
        </div>
      </Modal>
    );
  }
}

ConfirmDialog.defaultProps = {
  data: null,
  headerText: '',
  bodyText: '',
  confirmButtonText: strings.confirmButton,
  cancelButtonText: strings.cancelButton,

  iconType: null,
  hideCancelButton: false,
  hideCloseIcon: true,
  confirmButtonClass: '',
  cancelButtonClass: '',

  onConfirm: () => {},
  onCancel: () => {},
};

ConfirmDialog.propTypes = {
  data: PropTypes.object,
  headerText: PropTypes.string,
  bodyText: PropTypes.string,
  confirmButtonText: PropTypes.string,
  cancelButtonText: PropTypes.string,

  iconType: PropTypes.string,
  hideCancelButton: PropTypes.bool,
  hideCloseIcon: PropTypes.bool,
  confirmButtonClass: PropTypes.string,
  cancelButtonClass: PropTypes.string,

  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
};

export default ConfirmDialog;
